// extracted by mini-css-extract-plugin
export default {"layout":"GalleryNavigation_layout__U1ho2","layoutContainer":"GalleryNavigation_layoutContainer__6scks"};